import { FC, SVGProps } from 'react';

const MediaImageIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 24,
  color = '#2D2D2D',
  height = 24,
  width = 24,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.9758 8.64022C10.9758 9.58447 10.2104 10.3508 9.26522 10.3508C8.32098 10.3508 7.55469 9.58447 7.55469 8.64022C7.55469 7.695 8.32098 6.92969 9.26522 6.92969C10.2104 6.92969 10.9758 7.695 10.9758 8.64022Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.4997 15.5725L17.5506 12.7057C16.088 11.6428 14.0887 11.74 12.734 12.9303L5.04004 19.8337"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.50391 15.4783C4.34216 14.7081 5.64913 13.479 7.42384 14.4349C8.33989 14.9318 9.14994 15.4492 9.59823 15.7516"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.5 8.02465V15.9725C21.5 18.917 19.6572 20.9942 16.7126 20.9942H8.27763C5.33306 20.9942 3.5 18.917 3.5 15.9725V8.02465C3.5 5.08008 5.34279 3.00391 8.27763 3.00391H16.7126C19.6572 3.00391 21.5 5.08008 21.5 8.02465Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default MediaImageIcon;
